// extracted by mini-css-extract-plugin
module.exports = {"module1":"module1_module1__kS7pw","module1Container":"module1_module1Container__5z700"};